<template>
  <!-- 待结算订单 -->
  <div class="container">
    <div class="container_form">
      <el-form
        :inline="true"
        :model="motivateForm"
        style="
          padding-top: 20px;
          padding-left: 20px;
          margin-bottom: 20px;
          background-color: #fff;
          border-radius: 8px;
        "
        size="small"
        ref="motivateFormRefs"
      >
        <el-form-item label="结算批次名称" prop="settlementBatchName">
          <el-select
            filterable
            style="width: 100%"
            v-model="motivateForm.settlementBatchName"
            placeholder="请选择结算批次名称"
          >
            <el-option
              v-for="(item,index) in queryFormSettlementList"
              :key="index"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="安装师傅" prop="installerIds">
          <el-select
            multiple
            style="width: 100%"
            filterable
            v-model="motivateForm.installerIds"
            placeholder="请选择师傅名称"
          >
            <el-option
              v-for="item in allUserList"
              :key="item.id"
              :label="item.userName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属公司" prop="companyIds">
          <el-select
            multiple
            style="width: 100%"
            filterable
            v-model="motivateForm.companyIds"
            placeholder="请选择所属公司"
          >
            <el-option
              v-for="item in companyDrownList"
              :key="item.companyId"
              :label="item.companyManager"
              :value="item.companyId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="品牌" prop="brandIds">
          <el-select
            multiple
            style="width: 100%"
            filterable
            v-model="motivateForm.brandIds"
            placeholder="请选择品牌"
          >
            <el-option
              v-for="item in deviceBrandDrownList"
              :key="item.id"
              :label="item.brandName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="车型" prop="modelIds">
          <el-select
            multiple
            style="width: 100%"
            filterable
            v-model="motivateForm.modelIds"
            placeholder="请选择车型"
          >
            <el-option
              v-for="item in allDeviceModelDrownList"
              :key="item.id"
              :label="item.modelName + ' | ' + item.brandName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="省市区" prop="location">
          <el-cascader v-model="motivateForm.location" :options="regionOptions" :props="{ checkStrictly: true }" clearable filterable placeholder="请选择省市区" />
        </el-form-item>
        <el-form-item label="主机订单号" prop="mainOrderNo">
          <el-input
            v-model="motivateForm.mainOrderNo"
            placeholder="请输入主机订单号"
          ></el-input>
        </el-form-item>
        <el-form-item label="上游订单号" prop="upstreamOrderNo">
          <el-input
            v-model="motivateForm.upstreamOrderNo"
            placeholder="请输入上游订单号"
          ></el-input>
        </el-form-item>
        <el-form-item label="单号批量查询" prop="orderNoBatch">
          <el-input
            v-model="motivateForm.orderNoBatch"
            type="textarea"
            :rows="3"
            style="width: 300px"
            clearable
            placeholder="主机/上游订单号，最多1000个，支持换行、空格、逗号分隔"
          ></el-input>
        </el-form-item>
        <el-form-item label="客户名称" prop="customerName">
          <el-input
            v-model="motivateForm.customerName"
            placeholder="请输入客户名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="车架号" prop="vin">
          <el-input
            v-model="motivateForm.vin"
            placeholder="请输入车架号"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="getTableData(true)">查询</el-button>
          <el-button type="info" size="mini" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="container_table">
      <div class="table_btn">
        <el-button
          type="primary"
          size="mini"
          @click="showDialog('dialogFormAdd')"
          v-show="
            authorization('/home-admin/settlementManage/pending-orders/add')
          "
          >新增</el-button
        >
        <el-button
          type="info"
          size="mini"
          @click="showDialog('dialogImport')"
          v-show="
            authorization('/home-admin/settlementManage/pending-orders/import')
          "
          >导入</el-button
        >
        <el-button
          :disabled="multipleSelection.length <= 0"
          type="warning"
          size="mini"
          @click="showDialog('dialogFormEdit', 'batch')"
          v-show="
            authorization('/home-admin/settlementManage/pending-orders/edit')
          "
          >批量编辑费用</el-button
        >
        <el-button
          :disabled="multipleSelection.length <= 0"
          type="danger"
          size="mini"
          :loading="batchDeleteLoading"
          @click="handleBatchDelete"
          v-show="
            authorization('/home-admin/settlementManage/pending-orders/delete')
          "
          >批量删除</el-button
        >
        <el-button
          type="danger"
          plain
          size="mini"
          :loading="batchDeleteByBatchLoading"
          @click="openBatchDeleteByBatchDialog"
          v-show="
            authorization('/home-admin/settlementManage/pending-orders/delete')
          "
          >按批次删除</el-button
        >
      </div>
      <el-table
        :data="tableData"
        stripe
        height="80%"
        size="small"
        :header-cell-style="{
          'background-color': '#84aace4a',
          color: '#343333',
          'text-align': 'center',
        }"
        :cell-style="{ 'text-align': 'center' }"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="结算批次名称"
          width="120"
        >
          <template slot-scope="scope">
            <span 
              class="batch-name-link" 
              @click="jumpToReport(scope.row.settlementBatchName)"
            >
              {{ scope.row.settlementBatchName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="companyIdStr" label="所属公司"></el-table-column>
        <el-table-column prop="brandIdStr" label="品牌"></el-table-column>
        <el-table-column prop="carModelIdStr" label="车型"></el-table-column>
        <el-table-column
          prop="mainOrderNo"
          label="主机订单号"
          width="150"
        ></el-table-column>
        <el-table-column
          prop="upstreamOrderNo"
          label="上游订单号"
          width="150"
        ></el-table-column>
        <el-table-column prop="customerName" label="客户名称"></el-table-column>
        <el-table-column label="省市区" min-width="180">
          <template slot-scope="scope">{{ [scope.row.provinceName, scope.row.cityName, scope.row.areaName].filter(Boolean).join(' / ') || '-' }}</template>
        </el-table-column>
        <el-table-column prop="contactInfo" label="联系方式" width="120"></el-table-column>
        <el-table-column
          prop="vin"
          label="车架号"
          width="140"
        ></el-table-column>
        <el-table-column
          prop="installerIdStr"
          label="安装师傅"
        ></el-table-column>
        <!-- <el-table-column prop="managedByStr" label="代管人"></el-table-column> -->
        <el-table-column prop="accountingFee" label="核算费用">
          <template slot-scope="scope"><strong>{{ accountingFee(scope.row) }}</strong></template>
        </el-table-column>
        <el-table-column prop="installFee" label="安装费用"></el-table-column>
        <el-table-column prop="leakageDeduction" label="漏保扣款（减）" min-width="110"><template slot-scope="scope"><span style="color: #c45656">{{ scope.row.leakageDeduction == null ? 0 : scope.row.leakageDeduction }}</span></template></el-table-column>
        <el-table-column prop="insuranceDeduction" label="保险扣款（减）" min-width="110"><template slot-scope="scope"><span style="color: #c45656">{{ scope.row.insuranceDeduction == null ? 0 : scope.row.insuranceDeduction }}</span></template></el-table-column>
<el-table-column prop="regionalSubsidy" label="区域补贴"><template slot-scope="scope">{{ scope.row.regionalSubsidy == null ? 0 : scope.row.regionalSubsidy }}</template></el-table-column>
<el-table-column prop="specialSubsidy" label="特殊补贴"><template slot-scope="scope">{{ scope.row.specialSubsidy == null ? 0 : scope.row.specialSubsidy }}</template></el-table-column>
<el-table-column prop="monthlySubsidy" label="月度补贴"><template slot-scope="scope">{{ scope.row.monthlySubsidy == null ? 0 : scope.row.monthlySubsidy }}</template></el-table-column>
        <el-table-column prop="lineLength" label="用线长度"></el-table-column>
        <el-table-column prop="addOutlay" label="增项费用"></el-table-column>
        <el-table-column
          prop="remarks"
          show-overflow-tooltip
          label="备注"
          width="130"
        ></el-table-column>
        <el-table-column
          prop="settlementRemarks"
          show-overflow-tooltip
          label="结算备注"
          width="130"
        ></el-table-column>
        <!-- <el-table-column prop="source" label="来源">
          <template slot-scope="scope">
            <span>{{ scope.row.source ? "导入" : "手动新建" }}</span>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="createTime"
          label="创建时间"
          width="130"
        ></el-table-column>
        <el-table-column prop="createdByStr" label="创建人"></el-table-column>
        <el-table-column
          prop="updateTime"
          label="修改时间"
          width="130"
        ></el-table-column>
        <el-table-column prop="updatedByStr" label="修改人"></el-table-column>
        <el-table-column label="操作" fixed="right" width="130">
          <template slot-scope="scope">
            <el-tooltip
              effect="dark"
              content="编辑费用"
              placement="top-end"
              v-show="
                authorization(
                  '/home-admin/settlementManage/pending-orders/edit'
                )
              "
            >
              <el-button
                type="primary"
                icon="el-icon-edit"
                circle
                size="mini"
                style="margin:0 5px"
                @click="showDialog('dialogFormEdit', scope.row)"
              ></el-button>
            </el-tooltip>
            <el-tooltip
              effect="dark"
              content="编辑用线长度和增项费用"
              placement="top-end"
              v-show="
                authorization(
                  '/home-admin/settlementManage/pending-orders/edit'
                )
              "
            >
              <el-button
                type="warning"
                icon="el-icon-edit-outline"
                circle
                size="mini"
                style="margin:0px 5px 0px 0px"
                @click="showDialog('dialogFormEditLineAddoutlay', scope.row)"
              ></el-button>
            </el-tooltip>
            <!-- <el-tooltip effect="dark" content="下载" placement="top-end">
              <el-button
                type="warning"
                icon="el-icon-download"
                circle
                size="mini"
                style="margin-right: 5px; margin-left: 5px"
              ></el-button>
            </el-tooltip> -->
            <el-tooltip
              effect="dark"
              content="删除"
              placement="top-end"
              v-show="
                authorization(
                  '/home-admin/settlementManage/pending-orders/delete'
                )
              "
            >
              <el-popconfirm
                title="确认删除吗？"
                @confirm="deleteData(scope.row)"
              >
                <el-button
                  content="删除"
                  slot="reference"
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  size="mini"
                ></el-button>
              </el-popconfirm>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <div
        style="
          padding-top: 20px;
          height: 40px;
          background-color: #fff;
          width: 100%;
          border-radius: 0 0 8px 8px;
          text-align: right;
        "
      >
        <el-pagination
          background
          :page-sizes="sizes"
          :current-page="pageNum"
          :page-size="pageSize"
          layout="total,sizes,prev,pager,next"
          :total="total"
          @current-change="handleCurrentChange"
          @size-change="sizeChange"
        ></el-pagination>
      </div>
    </div>
    <!-- 编辑 -->
    <el-dialog
      :title="isBatch ? '批量编辑费用' : '编辑费用'"
      :visible.sync="dialogFormEdit"
      @close="editDialogClose"
      width="700px"
      :close-on-click-modal="false"
    >
      <EditForm
        ref="editForm"
        :currentData="currentData"
        :selectionData="multipleSelection"
        @editSuccess="
          getTableData(true);
          editDialogClose();
        "
      ></EditForm>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogClose" size="small">取 消</el-button>
        <el-button type="primary" @click="editSubmit" size="small"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 编辑用线长度和增项费用 -->
    <el-dialog
      title="编辑用线长度和增项费用"
      :visible.sync="dialogFormEditLineAddoutlay"
      @close="editLineAddoutlayDialogClose"
      width="700px"
      :close-on-click-modal="false"
    >
      <EditLineAddoutlayForm
        ref="editLineAddoutlayForm"
        :currentData="currentData"
        @editSuccess="
          getTableData(false);
          editLineAddoutlayDialogClose();
        "
      ></EditLineAddoutlayForm>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editLineAddoutlayDialogClose" size="small">取 消</el-button>
        <el-button type="primary" @click="editLineAddoutlaySubmit" size="small"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 新增 -->
    <el-dialog
      title="新增"
      :visible.sync="dialogFormAdd"
      fullscreen
      :close-on-click-modal="false"
    >
      <AddForm
        ref="addForm"
        :dialogisClose="dialogFormAdd"
        @close-dialog="closeAddDialog"
      ></AddForm>
    </el-dialog>

    <!-- 导入 -->
    <el-dialog
      title="导入数据"
      :visible.sync="dialogImport"
      width="600px"
      :close-on-click-modal="false"
      @close="dialogImportClose"
    >
      <div style="margin-top: 20px">
        <el-form
          label-width="130px"
          :model="importForm"
          ref="importFormRefs"
          :rules="importRules"
          style="padding-right: 20px"
          size="small"
        >
          <el-form-item label="结算批次名称" prop="settlementBatchName">
            <el-select
              filterable
              style="width: 100%"
              v-model="importForm.settlementBatchName"
              placeholder="请选择结算批次名称"
              allow-create
              default-first-option
            >
            <!-- :disabled="item.disabled"  -->
              <el-option
                v-for="(item,index) in settlementList"
                :key="index"
                :label="item.settlementBatchName"
                :value="item.settlementBatchName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="匹配字段" prop="matchField">
            <el-select style="width: 100%" v-model="importForm.matchField">
              <el-option label="主机厂订单号" value="1"></el-option>
              <el-option label="上游订单号" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="附件" prop="file">
            <Upload @customUpload="fileUpload" :customUploadDefault="false"  ref="uploadRefs" :accept="'.xls,.xlsx'" :limit="1">
              <span class="error_info" v-if="errorInfo">{{ errorInfo }}</span>
            </Upload>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogImport = false" size="small">取 消</el-button>
        <el-button 
          type="primary" 
          @click="submitImportData" 
          size="small"
          :loading="importLoading"
          :disabled="importLoading"
        >确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="按批次删除"
      :visible.sync="batchDeleteByBatchDialog"
      width="400px"
      :close-on-click-modal="false"
      @close="resetBatchDeleteByBatch"
    >
      <el-form label-width="120px" size="small">
        <el-form-item label="结算批次名称">
          <el-select
            v-model="batchDeleteBatchName"
            placeholder="请选择结算批次名称"
            filterable
            style="width: 100%"
          >
            <el-option
              v-for="(item, index) in queryFormSettlementList"
              :key="index"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="batchDeleteByBatchDialog = false">取 消</el-button>
        <el-button
          type="primary"
          size="small"
          :disabled="!batchDeleteBatchName"
          :loading="batchDeleteByBatchLoading"
          @click="submitBatchDeleteByBatch"
        >确 定</el-button>
      </span>
    </el-dialog>

     <!-- 未归属师傅提示弹窗 -->
     <UnassignedInstallerDialog
       :visible.sync="dialogUnassignedInstaller"
       :installer-list="unassignedInstallerList"
     />

     <!-- 导入错误提示弹窗 -->
     <el-dialog
       title="导入错误提示"
       :visible.sync="errorDialogVisible"
       width="80%"
       :close-on-click-modal="false"
       @close="handleErrorDialogClose"
     >
       <div style="max-height: 400px; overflow-y: auto;">
         <p 
           v-for="(item, index) in processedErrorList" 
           :key="index"
           style="line-height: 22px; margin-bottom: 8px;"
         >{{ item }}</p>
       </div>
       <span slot="footer" class="dialog-footer">
         <el-button @click="downloadErrorExcel" type="primary" size="small">下载Excel</el-button>
         <el-button @click="errorDialogVisible = false" size="small">关 闭</el-button>
       </span>
     </el-dialog>
  </div>
</template>

<script>
import { authorization } from "../../../authorization/authorization";
import AddForm from "./components/add.vue";
import EditForm from "./components/edit.vue";
import EditLineAddoutlayForm from "./components/edit-line-addoutlay.vue";
import Upload from "@/components/UpLoad";
import UnassignedInstallerDialog from "./components/UnassignedInstallerDialog.vue";
import * as XLSX from 'xlsx';
import { accountingFee } from '@/utils/accountingFee';
import { MAX_ORDER_BATCH_SIZE, parseOrderNoBatch } from '@/utils/orderBatchSearch';
import { regionData, codeToText } from 'element-china-area-data';
export default {
  name: "Motivate",
  components: {
    AddForm,
    EditForm,
    EditLineAddoutlayForm,
    Upload,
    UnassignedInstallerDialog,
  },
  data() {
    return {
      motivateForm: {
        location: [],
        settlementBatchName: "",
        installerIds: [],
        companyIds: [],
        brandIds: [],
        modelIds: [],
        mainOrderNo: "",
        upstreamOrderNo: "",
        orderNoBatch: "",
        customerName: "",
        vin: "",
      },
      tableData: [],
      regionOptions: regionData,
      total: 0,
      sizes: [10, 15, 50, 100],
      pageSize: 10,
      pageNum: 1,
      dialogFormEdit: false,
      dialogFormEditLineAddoutlay: false,
      dialogFormAdd: false,
      dialogImport: false,
      importForm: {
        settlementBatchName: "",
        matchField: "",
        file: "",
      },
      importRules: {
        settlementBatchName: [
          { required: true, message: "请输入结算批次名称", trigger: "change" },
        ],
        matchField: [
          { required: true, message: "请选择匹配字段", trigger: "blur" },
        ],
        file: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!this.importForm.file) {
                callback(new Error("请上传文件"));
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
      },
      errorInfo:null,
      settlementList: [],
      queryFormSettlementList: [],
      allUserList: this.$store.state.allUserList || [],
      multipleSelection: [],
      currentData: {},
      isBatch: false,
      importLoading: false,
      companyDrownList: [],
      deviceBrandDrownList: [],
      allDeviceModelDrownList: [],
      batchDeleteLoading: false,
      batchDeleteByBatchDialog: false,
      batchDeleteBatchName: "",
      batchDeleteByBatchLoading: false,
      dialogUnassignedInstaller: false,
      unassignedInstallerList: [],
      errorDialogVisible: false,
      processedErrorList: [],
      originalErrorList: [],
    };
  },
  created() {
    this.querySettlementList();
    this.getSettlementList();
    this.getCompanyDrown();
    this.queryDeviceBrandDrown();
    this.queryDeviceModelDrown();
    this.loadAllUserList();
    // 处理从报表页面跳转过来的查询参数
    this.handleRouteQuery();
  },
  methods: {
    accountingFee(row) {
      return accountingFee(row, this.$big);
    },
    authorization,
    // 加载所有用户列表
    async loadAllUserList() {
      try {
        // 调用store的action来获取最新的用户列表
        await this.$store.dispatch('setAllUserList');
        // 更新本地数据
        this.allUserList = this.$store.state.allUserList;
      } catch (error) {
        console.error('加载用户列表失败:', error);
        this.$message.error('加载用户列表失败');
      }
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getTableData(false);
    },
    sizeChange(val) {
      this.pageSize = val;
      this.getTableData(false);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleBatchDelete() {
      if (this.multipleSelection.length <= 0) {
        return;
      }
      const batchNames = [
        ...new Set(
          this.multipleSelection.map(
            (item) => item.settlementBatchName || "未命名批次"
          )
        ),
      ].filter((name) => name);
      if (batchNames.length !== 1) {
        this.$message.warning("请仅选择同一结算批次的订单进行批量删除");
        return;
      }
      const batchName = batchNames[0];
      const count = this.multipleSelection.length;
      this.$confirm(
        `确认删除（${batchName}：${count}个订单）批次订单？`,
        "提示",
        {
          type: "warning",
        }
      )
        .then(() => {
          const ids = this.multipleSelection
            .map((item) => item.id)
            .filter((id) => id);
          if (ids.length <= 0) {
            this.$message.warning("未找到可删除的订单");
            return;
          }
          this.batchDelete(ids);
        })
        .catch(() => {});
    },
    batchDelete(ids) {
      this.batchDeleteLoading = true;
      this.axios({
        method: "post",
        url: "/pending-settlement-order/del/batch",
        data: ids,
      })
        .then((res) => {
          if (res.data.code == 200) {
            this.$message({
              message: "批量删除成功",
              type: "success",
            });
            this.multipleSelection = [];
            this.getTableData(false);
            this.querySettlementList();
            this.getSettlementList();
          } else {
            this.$message({
              message: res.data.msg || res.data.message,
              type: "error",
            });
          }
        })
        .catch(() => {
        })
        .finally(() => {
          this.batchDeleteLoading = false;
        });
    },
    openBatchDeleteByBatchDialog() {
      this.batchDeleteBatchName = "";
      this.batchDeleteByBatchDialog = true;
    },
    resetBatchDeleteByBatch() {
      this.batchDeleteBatchName = "";
      this.batchDeleteByBatchDialog = false;
      this.batchDeleteByBatchLoading = false;
    },
    submitBatchDeleteByBatch() {
      if (!this.batchDeleteBatchName) {
        this.$message.warning("请选择结算批次名称");
        return;
      }

      this.$message.warning("正在删除中... 请等待删除完成提示消息");

      this.batchDeleteByBatchLoading = true;
      this.axios({
        method: "post",
        url: "/pending-settlement-order/del/batch/by-name",
        data: {
          settlementBatchName: this.batchDeleteBatchName,
        },
      })
        .then((res) => {
          if (res.data.code == 200) {
            this.$message.success("批次订单删除成功");
            this.resetBatchDeleteByBatch();
            this.getTableData(true);
          } else {
            this.$message.error(res.data.msg || res.data.message);
          }
          this.querySettlementList();
          this.getSettlementList();
        })
        .catch(() => {
        })
        .finally(() => {
          this.batchDeleteByBatchLoading = false;
        });
    },
    showDialog(show, row) {
      if (row && row != "batch") {
        this.isBatch = false;
        this.currentData = row;
      } else if (row == "batch") {
        this.isBatch = true;
      }
      this[show] = true;
    },
    editDialogClose() {
      this.dialogFormEdit = false;
      this.$refs.editForm.$refs.batchForm.resetFields();
    },
    editLineAddoutlayDialogClose() {
      this.dialogFormEditLineAddoutlay = false;
      if (this.$refs.editLineAddoutlayForm) {
        this.$refs.editLineAddoutlayForm.$refs.editForm.resetFields();
      }
    },
    editLineAddoutlaySubmit() {
      if (this.$refs.editLineAddoutlayForm) {
        this.$refs.editLineAddoutlayForm.editSubmit();
      }
    },
    closeAddDialog() {
      this.dialogFormAdd = false;
      this.$refs.addForm.$refs.formRefs.resetFields();
      this.getTableData(true);
      this.querySettlementList();
      this.getSettlementList();
    },
    querySettlementList() {
      //结算批次下拉
      this.axios({
        method: "post",
        url: "/pending-settlement-order/listSettlementNameAndStatus",
      }).then((res) => {
        this.settlementList = res.data.data;
      });
    },
    getSettlementList(){
      this.axios({
        method: "post",
        url: "/pending-settlement-order/listSettlementName",
      }).then((res) => {
        this.queryFormSettlementList = res.data.data;
      })
    },
    getTableData(flag) {
      const orderNumbers = parseOrderNoBatch(this.motivateForm.orderNoBatch);
      if (orderNumbers.length > MAX_ORDER_BATCH_SIZE) {
        this.$message.warning(`单号批量查询最多支持${MAX_ORDER_BATCH_SIZE}个`);
        return;
      }
      if (flag) {
        this.pageNum = 1;
        this.pageSize = 10;
      }
      //获取表格数据
      this.axios({
        method: "post",
        url: "/pending-settlement-order/list",
        data: {
          page: this.pageNum,
          size: this.pageSize,
          queryInfoParams: {
            settlementBatchName: this.motivateForm.settlementBatchName,
            installerIds: this.motivateForm.installerIds,
            companyIds: this.motivateForm.companyIds,
            brandIds: this.motivateForm.brandIds,
            modelIds: this.motivateForm.modelIds,
            mainOrderNo: this.motivateForm.mainOrderNo,
            upstreamOrderNo: this.motivateForm.upstreamOrderNo,
            orderNoList: orderNumbers.join(','),
            customerName: this.motivateForm.customerName,
            vin: this.motivateForm.vin,
            provinceName: codeToText[(this.motivateForm.location || [])[0]] || '',
            cityName: codeToText[(this.motivateForm.location || [])[1]] || '',
            areaName: codeToText[(this.motivateForm.location || [])[2]] || '',
          },
        },
      }).then((res) => {
        this.tableData = res.data.data.list;
        this.total = res.data.data.total;
      });
    },
    editSubmit() {
      if (this.isBatch) {
        this.$refs.editForm.bacthSubmit();
      } else {
        this.$refs.editForm.editSubmit();
      }
    },
    deleteData(data) {
      this.axios({
        method: "DELETE",
        url: `/pending-settlement-order/del/${data.id}`,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.getTableData(false);
          this.querySettlementList();
          this.getSettlementList();
        } else {
          this.$message({
            message: res.data.msg || res.data.message,
            type: "error",
          });
        }
      });
    },
    fileUpload(file) {
      this.importForm.file = file;
    },
    submitImportData() {
      this.$refs.importFormRefs.validate((valid) => {
        if (valid) {
          this.importLoading = true;
          const data = new FormData();
          data.append("file", this.importForm.file.file);
          data.append(
            "settlementBatchName",
            this.importForm.settlementBatchName
          );
          data.append("matchField", this.importForm.matchField);
          this.axios({
            url: "/pending-settlement-order/import",
            method: "post",
            headers: {
              "Content-Type": "multipart/form-data",
            },
            data,
          }).then((res) => {
            if (res.data.code == 200) {
              if(res.data.data.errorList && res.data.data.errorList.length > 0){
                // 检查是否包含安装师傅相关的错误
                const hasInstallerError = this.hasInstallerErrors(res.data.data.errorList)
                const hasScopeError = res.data.data.errorList.some(item => item.includes("授权范围"));
                if(hasInstallerError || hasScopeError){
                  // 包含安装师傅错误，使用对话框形式
                  this.originalErrorList = res.data.data.errorList
                  // 处理错误列表，对包含安装师傅的错误进行分组和排序
                  this.processedErrorList = this.processErrorList(res.data.data.errorList)
                  // 显示错误对话框
                  this.errorDialogVisible = true
                } else {
                  // 不包含安装师傅错误，使用原来的message形式
                  let msg = ''
                  res.data.data.errorList.forEach((item) =>{
                    msg += '<p style="line-height: 22px;">' + item + '</p>'
                  })
                  this.$message({
                    type: 'warning',
                    dangerouslyUseHTMLString: true,
                    message: msg,
                    duration: 0,
                    showClose: true
                  });
                }
              }else{
                this.$message({
                  message: "导入成功",
                  type: "success",
                });
                this.dialogImportClose();
                this.getTableData(false);
                
                // 导入成功后，检查是否有未归属的师傅
                if(res.data.data && res.data.data.unassignedInstallerList && res.data.data.unassignedInstallerList.length > 0){
                  // 有未归属的师傅，显示弹窗
                  this.unassignedInstallerList = res.data.data.unassignedInstallerList;
                  this.dialogUnassignedInstaller = true;
                }
              }
            } else {
              this.$message({
                message: res.data.message,
                type: "error",
              });
              this.errorInfo = res.data.message;
            }
            this.$refs.uploadRefs.fileList = [];
            this.importLoading = false;
          }).catch(err=>{
            this.$refs.uploadRefs.fileList = [];
            this.importLoading = false;
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 检查错误列表中是否包含安装师傅相关的错误
    hasInstallerErrors(errorList) {
      if (!errorList || errorList.length === 0) {
        return false;
      }
      // 匹配包含安装师傅的错误信息格式
      const installerErrorPattern = /所属【([^】]+)】安装师傅/;
      return errorList.some(error => installerErrorPattern.test(error));
    },
    // 处理错误列表，对包含安装师傅的错误进行分组和排序
    processErrorList(errorList) {
      if (!errorList || errorList.length === 0) {
        return [];
      }
      
      // 用于存储包含安装师傅的错误信息，按师傅分组
      const installerErrorMap = new Map();
      // 其他错误信息
      const otherErrors = [];
      
      // 匹配包含安装师傅的错误信息格式：订单为：【xxx】主机厂及【xxx】上游订单号的订单所属【xxx】安装师傅在...
      const installerErrorPattern = /所属【([^】]+)】安装师傅/;
      
      errorList.forEach(error => {
        const match = error.match(installerErrorPattern);
        if (match) {
          const installerName = match[1]; // 提取师傅名称
          if (!installerErrorMap.has(installerName)) {
            installerErrorMap.set(installerName, []);
          }
          installerErrorMap.get(installerName).push(error);
        } else {
          // 不包含安装师傅信息的错误，直接添加到其他错误列表
          otherErrors.push(error);
        }
      });
      
      // 将按师傅分组的错误转换为数组，并按师傅名称排序
      const sortedInstallerErrors = Array.from(installerErrorMap.entries())
        .sort((a, b) => a[0].localeCompare(b[0], 'zh-CN')) // 按师傅名称中文排序
        .flatMap(([installerName, errors]) => {
          // 对每个师傅的错误也进行排序（按原始顺序，或者可以按订单号排序）
          return errors.sort();
        });
      
      // 合并结果：先显示按师傅排序的安装师傅相关错误，然后是其他错误
      return [...sortedInstallerErrors, ...otherErrors];
    },
    // 下载错误列表为Excel
    downloadErrorExcel() {
      // 匹配包含安装师傅的错误信息格式
      const installerErrorPattern = /所属【([^】]+)】安装师傅/;
      
      // 将错误列表转换为Excel数据格式，提取安装师傅名称
      const excelData = this.processedErrorList.map((error, index) => {
        const match = error.match(installerErrorPattern);
        const installerName = match ? match[1] : ''; // 提取师傅名称，如果没有则为空
        return {
          '序号': index + 1,
          '安装师傅': installerName,
          '错误信息': error
        };
      });

      // 创建工作表
      const ws = XLSX.utils.json_to_sheet(excelData, { 
        header: ['序号', '安装师傅', '错误信息']
      });

      // 设置列宽
      ws['!cols'] = [
        { wch: 10 },  // 序号列宽
        { wch: 15 },  // 安装师傅列宽
        { wch: 80 }   // 错误信息列宽
      ];

      // 创建工作簿
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, '导入错误列表');

      // 生成文件名（使用当前时间戳）
      const now = new Date();
      const timestamp = `${now.getFullYear()}${(now.getMonth() + 1).toString().padStart(2, '0')}${now.getDate().toString().padStart(2, '0')}_${now.getHours().toString().padStart(2, '0')}${now.getMinutes().toString().padStart(2, '0')}${now.getSeconds().toString().padStart(2, '0')}`;
      const fileName = `导入错误列表_${timestamp}.xlsx`;

      // 导出文件
      XLSX.writeFile(wb, fileName);
      
      this.$message({
        message: "下载成功",
        type: "success",
      });
    },
    // 错误对话框关闭处理
    handleErrorDialogClose() {
      this.processedErrorList = [];
      this.originalErrorList = [];
    },
    dialogImportClose() {
      this.$refs.uploadRefs.fileList = [];
      this.$refs.importFormRefs.resetFields();
      this.importForm.file = "";
      this.dialogImport = false;
      this.importLoading = false;
      this.getTableData(true);
      this.querySettlementList();
      this.getSettlementList();
    },
    reset(){
      this.$refs.motivateFormRefs.resetFields();
      this.getTableData(true);
    },
    getCompanyDrown() {
      this.axios({
        method: "get",
        url: "/v1/web/company-manager/select-company-drown",
      }).then((res) => {
        this.companyDrownList = res.data.data;
      });
    },
    queryDeviceBrandDrown() {
      this.axios({
        method: "get",
        url: "/v1/web/device-brand/select-business-brands",
      }).then((res) => {
        this.deviceBrandDrownList = res.data.data.list;
      });
    },
    queryDeviceModelDrown() {
      this.axios({
        method: "get",
        url: "/v1/web/device-brand/select-business-models",
      }).then((res) => {
        this.allDeviceModelDrownList = res.data.data.list;
      });
    },
    handleRouteQuery() {
      // 处理从报表页面跳转过来的查询参数
      const query = this.$route.query;
      if (query.settlementBatchName && query.autoSearch === 'true') {
        // 设置结算批次名称并自动查询
        this.motivateForm.settlementBatchName = query.settlementBatchName;
        // 等待数据加载完成后再查询
        this.$nextTick(() => {
          setTimeout(() => {
            this.getTableData(true);
          }, 500); // 给一点时间让下拉选项加载完成
        });
      } else {
        // 正常加载数据
        this.getTableData(true);
      }
    },
     jumpToReport(batchName) {
       // 跳转到结算报表页面并自动查询指定批次
       this.$router.push({
         path: '/home-admin/settlementManage/report',
         query: { 
           settlementBatchName: batchName,
           autoSearch: 'true'
         }
       });
     }
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
  padding: 20px;
  background-color: rgb(238, 238, 238);
  box-sizing: border-box;
}
.table_btn {
  background-color: #fff;
  padding: 20px 0 10px 0px;
  border-radius: 8px 8px 0 0;
}
.container_table {
  height: calc(100vh - 78px - 220px);
  padding: 20px 5px 0 20px;
  background-color: #fff;
  border-radius: 8px;
}
::v-deep .el-dialog__body {
  padding-top: 0px;
}
.error_info{
  color: #d72822;
  font-size: 12px;
}
.batch-name-link {
  color: #409EFF;
  cursor: pointer;
}
.batch-name-link:hover {
  text-decoration: underline;
}
</style>
